import {
  Box,
  Flex,
  HStack,
  StyleProps,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react'
import { ReactNode } from 'react'

import { topbarRef } from '../../App'
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary'
import { NotificationsMenu } from '../Notifications/NotificationsMenu'
import { ProfileMenu } from './ProfileMenu'

export interface TopBarProps extends StyleProps {
  headerSlot?: ReactNode
}

export const Topbar = ({ headerSlot, ...props }: TopBarProps) => {
  const headerSlotColor = useColorModeValue(
    'presets.neutral.100',
    'presets.neutral.0',
  )

  return (
    <Flex
      as="header"
      ref={topbarRef}
      position="relative"
      className="topBar"
      padding="10.5px 28px"
      borderBottom="1px solid"
      borderBottomColor="presets.neutral.25"
      backgroundColor="white"
      alignItems="center"
      _dark={{
        backgroundColor: '#0F3744',
        borderBottomColor: 'rgba(255, 255, 255, 0.08)',
      }}
      {...props}
    >
      <VStack>
        {headerSlot && (
          <HStack alignItems="center" gap="18px">
            <Box
              fontSize="24px"
              lineHeight="normal"
              fontWeight="400"
              color={headerSlotColor}
            >
              {/* Isolate the header slot so a broken slot can't take down the
                  rest of the topbar (notifications, profile menu). Use a
                  compact fallback that fits the header bar. */}
              <ErrorBoundary
                renderError={() => (
                  <Text variant="error">Unable to load header</Text>
                )}
              >
                {headerSlot}
              </ErrorBoundary>
            </Box>
          </HStack>
        )}
      </VStack>
      <Box flex="1"></Box>
      <Flex
        flexShrink={0}
        flexGrow={0}
        alignItems="center"
        zIndex="100"
        gap="20px"
      >
        <NotificationsMenu />
        <ProfileMenu />
      </Flex>
    </Flex>
  )
}
